import { TxpDatapoint } from 'txp-data';
import LogNames from 'txp-data/lib/schema/telemetry/LogNames';

export default function populateTxpDataPointObject(
    source: string,
    datapoint: TxpDatapoint
): TxpDatapoint {
    if (!datapoint) {
        datapoint = {};
    }
    datapoint[LogNames.source] = source;
    return datapoint;
}
